import { useTranslation } from 'react-i18next';
import { useAuth } from '@/components/providers/AuthProvider';

/**
 * Hook to get community-specific translations with fallback to default
 */
export function useCommunityTranslations() {
  const { t } = useTranslation(['domain']);
  const { currentCommunity } = useAuth();

  /**
   * Get a community-specific translation with fallback to default
   * @param key The translation key under Community.{community}.{key}
   * @returns The translated string
   */
  const getCommunityTranslation = (key: string): string => {
    // First try community-specific translation
    if (currentCommunity) {
      const communityKey = `Community.${currentCommunity}.${key}`;
      const communityTranslation = t(communityKey, '');
      
      // If community-specific translation exists and is not empty, use it
      if (communityTranslation && communityTranslation !== communityKey) {
        return communityTranslation;
      }
    }
    
    // Fallback to default translation
    const defaultKey = `Community.default.${key}`;
    return t(defaultKey);
  };

  return {
    getCommunityTranslation,
  };
} 